<template>
  <div>
    <b-row class="search-box">
      <b-col sm="12" xl="7" lg="7" md="12" class="mr-n1px p-0">
        <div>
          <b-form-input
              class="border-0"
              :placeholder="$t('pages.keyword.keyword_input.keyword_placeholder')"
              required
              v-model="keyword"
              :disabled="loading"
              :class="{'is-invalid': submitted && $v.keyword.$error }"
          ></b-form-input>
          <div
              v-if="submitted && !$v.keyword.required"
              class="invalid-feedback"
          >
            {{ $t('pages.keyword.keyword_input.validations.keyword_required') }}
          </div>

          <div v-if="submitted && !$v.keyword.maxLength"
               class="invalid-feedback"
          >
            {{ $t('pages.keyword.keyword_input.validations.keyword_max', {max: $v.keyword.$params.maxLength.max}) }}
          </div>
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </b-col>

      <b-col sm="5" md="5" xl="2" lg="2" class="mr-n1px p-0 mt-3 mt-xl-0 mt-lg-0">
        <keyword-marketplace
            @selected="setMarketplace"
            :loading="loading"
            :invalid="submitted && $v.marketplace.$error"
        />
        <div
            v-if="submitted && !$v.marketplace.required"
            class="invalid-feedback d-grid"
        >
          {{ $t('pages.keyword.keyword_input.validations.marketplace_required') }}
        </div>
      </b-col>

      <b-col sm="5" md="5" xl="2" lg="2" class="mr-n1px p-0 mt-3 mt-xl-0 mt-lg-0">
        <keyword-language
            @selected="setLanguage"
            :loading="loading"
            :marketplace="marketplace ? marketplace.marketplace_id : null"
            :invalid="submitted && $v.language.$error"
        />
        <div
            v-if="submitted && !$v.language.required"
            class="invalid-feedback d-grid"
        >
          {{ $t('pages.keyword.keyword_input.validations.language_required') }}
        </div>
      </b-col>

      <b-col sm="2" md="2" xl="1" lg="1" class="mr-n1px p-0 mt-3 mt-xl-0 mt-lg-0">
        <b-button variant="success" @click="handleSearch" :disabled="loading || disabled">
          <b-spinner v-if="loading"></b-spinner>
          <i v-else class="bx bx-search-alt font-size-20"></i>
          <span class="d-xl-none d-lg-none d-md-none font-size-16 mx-2">
                        {{ $t('pages.keyword.keyword_input.search') }}
          </span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import KeywordMarketplace from "./Widget/KeywordMarketplace";
import KeywordLanguage from "./Widget/KeywordLanguage";
import {required, maxLength} from "vuelidate/lib/validators";

export default {
  name: "KeywordComponent",
  props: {
    loading: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  components: {KeywordLanguage, KeywordMarketplace},
  data() {
    return {
      keyword: '',
      language: null,
      marketplace: null,
      submitted: false,
    }
  },
  validations: {
    keyword: {
      required,
      maxLength: maxLength(255)
    },
    language: {
      required
    },
    marketplace: {
      required
    }
  },
  methods: {
    setLanguage(language) {
      this.language = language
    },
    setMarketplace(marketplace) {
      this.marketplace = marketplace
    },
    handleSearch() {
      this.submitted = true
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      }

      this.$emit('search', {
        location_code: this.marketplace.location_code,
        marketplace_id: this.marketplace.marketplace_id,
        language_code: this.language.code,
        keyword: this.keyword
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-box {

  .form-control {
    border-radius: 30px 0 0 30px !important;
    height: 55px;
    width: 100%;
  }

  .dropdown {
    height: 55px;
    width: 100%;
  }

  .btn {
    width: 100%;
    height: 55px;
    border-radius: 0 30px 30px 0 !important;
  }

  ::v-deep.dropdown-toggle {
    border-radius: 0 !important;
  }

  .search-icon {
    font-size: 18px;
    position: absolute;
    left: 18px;
    top: 10px;
    line-height: 38px;
  }

  margin-left: auto;
  margin-right: auto;
}

.mr-n1px {
  margin-right: -1px;
}

@media (max-width: 540px) {
  .search-box {
    .form-control {
      border-radius: 4px !important;
    }

    .dropdown {
      border-radius: 4px !important;
    }

    .btn {
      border-radius: 4px !important;
    }
  }
}

@media (max-width: 960px) {
  .search-box {
    .form-control {
      border-radius: 4px !important;
    }

    .btn {
      border-radius: 0 4px 4px 0 !important;
    }
  }
}

</style>